const DEVELOPMENT = 'development',
  TEST = 'test',
  QA = 'qa',
  PROD = 'prod';

const hostnames: { [key: string]: string } = {
  localhost: DEVELOPMENT,
  'test.': TEST,
  'test1.': TEST,
  'local.': TEST,
  'qa.': QA,
};

const apiRoots: { [key: string]: string } = {
  [DEVELOPMENT]: 'https://api.test.ramseysolutions.net/ramseyplus/learn',
  [TEST]: 'https://api.test.ramseysolutions.net/ramseyplus/learn',
  [QA]: 'https://api.qa.ramseysolutions.net/ramseyplus/learn',
  [PROD]: 'https://api.ramseysolutions.net/ramseyplus/learn',
};

const getEnvKey = (host: string) =>
  Object.keys(hostnames).find(key => host.includes(key));

const getEnvironment = (envKey: string) => hostnames[envKey] || PROD;

const getApiRoot = (environment: string) => apiRoots[environment];

/**
 * Gets the BaseURL for LearnAPI, that corresponds to this environment.
 *
 * @param hostname
 * @returns
 */
export const baseUrl = (hostname: string): string => {
  const key = getEnvKey(hostname);
  const env = getEnvironment(key as string);
  const toReturn = getApiRoot(env);
  return toReturn;
};
